var map = {
	"./black.png": "10af",
	"./black_hover.png": "3587",
	"./black_lock.png": "b74c",
	"./black_unlock.png": "1d88",
	"./blue.png": "59e0",
	"./blue_hover.png": "c10f",
	"./blue_lock.png": "b929",
	"./blue_unlock.png": "69a2",
	"./green.png": "cfe8",
	"./green_hover.png": "c3bb",
	"./green_lock.png": "9ec9",
	"./green_unlock.png": "8a813",
	"./orange.png": "6025",
	"./orange_hover.png": "9dad",
	"./orange_lock.png": "3f67",
	"./orange_unlock.png": "dbfe",
	"./white.png": "8e11",
	"./white_hover.png": "25be",
	"./yellow.png": "636c",
	"./yellow_hover.png": "b71a",
	"./yellow_lock.png": "586e",
	"./yellow_unlock.png": "d285"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "21d4";